import { channels } from './channels';
import { id, root } from './social-media';

export const socialMedia = {
  ...root,
  id,
  channels,
};
